import { NavItems } from "./NavItems";
import { useState } from "react";
import "./navBar.scss";
import { FaBars } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { useSelector } from "react-redux";
import { AuthContext } from "../../context/AuthContext";
import { useEffect } from "react";
import { FaShoppingCart } from "react-icons/fa";
import { toast } from "react-toastify";
import axios from "axios";
import SlideInModal from "../slideInModal/SlideInModal";
import Cart from "../Cart/Cart";
import GoogleTranslate from "../GoogleTranslate";

const Navbar = () => {
  const { buyer, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const products = useSelector((state) => state.cart.products);
  const [prevProductCount, setPrevProductCount] = useState(products.length);

  const navigate = useNavigate();

  // useEffect(() => {
  //   if (products.length > prevProductCount) {
  //     toast.success("New product added to the cart!", {
  //       position: toast.POSITION.BOTTOM_LEFT,
  //     });
  //   }
  //   setPrevProductCount(products.length);
  // }, [products]);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClickClose = () => {
    setOpen(false);
  };
  const openPopup = () => {
    setShow(true);
  };
  const cloesPopup = () => {
    setShow(false);
  };

  const handleLogout = async () => {
    try {
      await axios.get("/buyer-logout");
      localStorage.removeItem("buyer");
      dispatch({ type: "LOGOUT" });
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const openCart = () => {
    setIsModalOpen(true);
  };

  return (
    <div className="__fw">
      <div className="__mw">
        <nav className="NavbarItems">
          <div className="Logo_wrp">
            <Link to="/">
              <img
                className="logo_img"
                src={require("../../img/logo.png")}
                alt=""
              />
            </Link>
          </div>
          <div className="Hamburger-Cross-Icons">
            {open ? (
              <IoClose color="black" size={27} onClick={handleClickClose} />
            ) : (
              <FaBars color="black" size={27} onClick={handleClickOpen} />
            )}
          </div>
          <ul className={open ? "MenuItems active" : "MenuItems"}>
            <Link to={"/"} onClick={handleClickClose}>
              <li className="nv">Home</li>
            </Link>
            <Link to={"/offers"} onClick={handleClickClose}>
              <li className="nv">Flash Sale</li>
            </Link>
            <Link to={"/shop"} onClick={handleClickClose}>
              <li className="nv">Offers</li>
            </Link>

            {/* <Link to={"/contact"} onClick={handleClickClose}>
              <li className="nv">Contact</li>
            </Link> */}
            <div className="item" onClick={openCart}>
              <div className="icons">
                <div className="shoppingCart">
                  <div className="cartIcon">
                    <FaShoppingCart />
                    <span>{products.length}</span>
                  </div>
                </div>
              </div>
            </div>
            {/* <GoogleTranslate /> */}
          </ul>
        </nav>
        <>
          <SlideInModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          >
            <Cart closeCart={() => setIsModalOpen(false)} />
          </SlideInModal>
        </>
      </div>
    </div>
  );
};
export default Navbar;
